module.exports = __webpack_public_path__ + "img/consultation.41a97f6.jpg";